module.exports = __webpack_public_path__ + "files/Trustami_TWS_Bachelor_Master_Thesis__Gain_Insights_of_3D_Marketplace_Data.pdf";